import React from 'react';
import PropTypes from 'prop-types';
import DropdownBase from './DropdownBase';

class Dropdown extends React.Component {
  static propTypes = {
    /** Classname to be applied to Dropdown */
    className: PropTypes.string,
    /** Callback fired when Change event is called */
    onChange: PropTypes.func.isRequired,
    /** If `true`, Dropdown will be Disabled */
    isDisabled: PropTypes.bool,
    /** If `true`, Dropdown will show loader till the data is loaded */
    isLoading: PropTypes.bool,
    /** If `true`, Dropdown will show cross icon to delete the value*/
    isClearable: PropTypes.bool,
    /** If `true`, Dropdown will autoSearch for the records value*/
    isSearchable: PropTypes.bool,
    /** It will show label for the dropdown*/
    label: PropTypes.string.isRequired,
    /** Function to override default value rendering */
    renderValue: PropTypes.func,
    /** Function to override default filtering */
    onFilter: PropTypes.func,
    /** Default value to seed uncontrolled component */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** Function to override default arrowRenderer */
    renderIcon: PropTypes.func,
    /** If `true`, Dropdown border to be shown in red color */
    hasError: PropTypes.bool,
  };

  getStyles = type => {
    switch (type) {
      case 'profile':
        return {
          root: {
            maxWidth: '520px',
          },
          floatLabel: {
            position: 'absolute',
            top: 'calc(50% - 8px)',
            left: '16px',
            transition: 'transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
            transformOrigin: 'top left',
            fontSize: '1rem',
            // fontFamily: "EYInterstate"
          },
          floatLabelShrink: {
            left: '12px',
            fontSize: '0.7em',
            top: '12px',
          },
          '@global': {
            '.Select-arrow-zone': {
              right: '6px',
              // transform: 'translateY(calc(-25%))',
              // '-ms-transform': 'translateY(-25%)',
              // '-webkit-transform': 'none',
              transform: 'none',
            },
            '.StyledComponent-floatLabel-240': {
              left: '17px',
            },
            '.Select.has-value.is-clearable.Select--single > .Select-control .Select-value': {
              padding: '0px 0px 0px 15px',
              fontSize: '1rem',
              color: 'grey',
            },
          },
        };
      case 'registration':
        return {
          root: {
            maxWidth: '520px',
          },
        };
      default:
        return {};
    }
  };

  getSettings = type => {
    switch (type) {
      default:
        return {
          renderIcon: () => null,
          renderOption: (data, searchText) => {
            const highlight = (needle, haystack) => haystack.replace(new RegExp(needle, 'gi'), str => `<strong>${str}</strong>`);
            const labelText = data.label !== null && data.label.length >= 1 ? highlight(searchText, data.label) : '';
            //pass additional info true if we want email beneath name
            if(this.props.additionalInfoDropdown){
            return (
              //add padding as we have removed padding in dropdownbase 'select-option'
              <div className="autocomplete-item-wrapper additional-info-new-dropdown" id={data.id}
              style={{padding:'10px', display: (data.name==="delegatecontact" && (data.isActive || data.email === "")) && 'none'}}>
                <div>
                <span className="autocomplete-item-name availableData" dangerouslySetInnerHTML={{ __html: labelText }}/>
                {data.isAvailable && <span className='availableCaseContact'>, {data.isAvailable}</span>}
                {data.email && <p className='availableEmail'>{data.email}</p>}
                </div>
              </div>
            );
            }
            else {
              return(
                //add padding as we have removed padding in dropdownbase 'select-option'
              <div style={{padding:'12px'}} className="autocomplete-item-wrapper">
                <div className="autocomplete-item-name" dangerouslySetInnerHTML={{ __html: labelText }} />
              </div>
              )
            }
          },
          renderValue: conf => {
            const { value, disabled } = conf;
            return (
              <div className="Select-value">
                <span style={{ color: !disabled ? 'black' : '#aa9fa2' }}>{value.label}</span>
                {/*add line just for unavailable message */}
                {this.props.additionalInfoDropdown && value.isAvailable && <span className='availableCaseContact'>, {value.isAvailable}</span>}
              </div>
            );
          },
        };
    }
  };

  render() {
    const { styleType } = this.props;
    const styles = this.getStyles(styleType);
    const settings = this.getSettings(styleType);

    return <DropdownBase {...settings} styles={styles} {...this.props} />;
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/ui/library/DropdownNew/Dropdown.js